// Components/MessagesArea/components/MessagesContainer.jsx
import React from 'react';
import { Box } from '@mui/material';
import LoadingIndicator from './LoadingIndicator';
import EmptyConversation from './EmptyConversation';
import ConversationStart from './ConversationStart';
import MessagesList from './MessagesList';

const MessagesContainer = ({
    isLoadingMessage,
    isLoadingCurrentMode,
    isLoadingMore,
    hasMore,
    allMessages,
    contactActive,
    endOfMessagesRef
}) => {
    // Si está cargando los mensajes iniciales, mostrar solo el indicador de carga
    if (isLoadingMessage) {
        return <LoadingIndicator type="area" text="Cargando mensajes..." />;
    }
    if (isLoadingCurrentMode) {
        return <LoadingIndicator type="area" text="Cambiando el modo de atención..." />;
    }

    return (
        <>
            {/* Indicador de carga para más mensajes anteriores */}
            {isLoadingMore && (
                <LoadingIndicator type="mini" text="Cargando mensajes antiguos..." />
            )}

            {/* Mostrar un mensaje cuando no hay más mensajes para cargar */}
            {!hasMore && allMessages.length > 0 && (
                <ConversationStart />
            )}

            {/* Mensaje cuando no hay mensajes */}
            {allMessages.length === 0 && contactActive ? (
                <EmptyConversation />
            ) : (
                <>
                    {/* Lista de mensajes */}
                    <MessagesList messages={allMessages} />

                    {/* Espaciador y elemento para scroll */}
                    <Box sx={{ height: '20px' }}></Box>
                    <div ref={endOfMessagesRef} style={{ height: '1px' }} />
                </>
            )}
        </>
    );
};

export default MessagesContainer;